const state = {
  userId: null,
  firstName: null,
  lastName: null,
  email: null,
  tokenExpire: null,
  accessToken: null
}

const actions = {
  setUser ({ commit }, payload) {
    commit('SET_USER', payload)
  },
  logout ({ commit }) {
    commit('USER_LOGOUT')
  }
}

const mutations = {
  SET_USER (state, payload) {
    state.userId = payload.userId
    state.firstName = payload.firstName
    state.lastName = payload.lastName
    state.email = payload.email
    state.tokenExpire = payload.tokenExpire
    state.accessToken = payload.accessToken
  },
  USER_LOGOUT (state) {
    state.userId = null
    state.firstName = null
    state.lastName = null
    state.email = null
    state.tokenExpire = null
    state.accessToken = null
  }
}

const getters = {
  user: (state) => ({ ...state }),
  accessToken: (state) => state.accessToken,
  tokenExpire: (state) => state.tokenExpire
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
